import { FieldType, Model, Schema } from "@core/index";

export interface ICheckinInfoRequest {
    refrenceNumber?: number;      // Identity number (seed=1)
    flightNumber?: number;        // Selected flight segment
}

export class CheckinInfoRequest extends Model implements ICheckinInfoRequest {
    public static schema: Schema = new Schema("CheckinInfoRequest");
    public refrenceNumber?: number;
    public flightNumber?: number;


    constructor(values: ICheckinInfoRequest) {
        super(CheckinInfoRequest.schema);
        this.setValues(values);
    }
}

CheckinInfoRequest.schema.addField("refrenceNumber").type(FieldType.Number).required().pattern(/^[0-9]*$/);
CheckinInfoRequest.schema.addField("flightNumber").type(FieldType.FlightNumber).required();